
import { useLocation, useNavigate } from "react-router-dom";

import { useState } from "react";
import * as yup from 'yup';
import { useFormik } from "formik";


import { BackButton, CancelButton, SubmitButton } from "../../../Components/Utils/Buttons";
import { NuDate, NuInput } from "../../../Components/Utils/Input";
import FormikSelectTwo from "../../../Components/Utils/Select";

import useEditFormData from "../../../Components/Hooks/useEditFormData";
import Breadcrumb from "../../../Components/Utils/Breadcrumb";


function EditTasks() {
  const navigate = useNavigate();
    const location = useLocation();
    const data = location.state.data;
  
    
  const from = location.state.from;

  const {  editFormData } =
  useEditFormData(); 
     const [createNew, setCreateNew] = useState({
    
    Activity: data?.Activity  || "",
    StartDate: data?.StartDate  || "",
    DueDate: data?.DueDate  || "",
    Duration: data?.Duration  || "",
    Priority: data?.Priority  || "",
    Status: data?.Status  || "",
    

    
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
          }),
    onSubmit: async (value, { resetForm }) => {
      editFormData(
        `/employees/${data.employeeId}`,
        value,
        resetForm,
        from,
      );},
  });
 
 

  return (
    <div className=" w-full h-full py-2 px-4 ">
         <div className="flex justify-between w-full "> 
         <Breadcrumb
          items={[
            {
              name: "Task",
              link: "/tasks/",
            },
            { name: "Edit" },
          ]}
        />     
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-155px)] bg-white rounded-xl overflow-hidden mt-4">
        <div className=" w-full h-full flex justify-start content-start flex-wrap py-2 px-4  overflow-y-auto">
            <div className="w-full">
              <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4">
                Tasks:
              </p>
            </div>
            <NuInput
               type="text"
               label="Activity"
               placeholder="Type here"
               formik={formik}
               name="Activity"
               width="w-full md:w-1/3 md:-mt-2"
             />
              <NuDate
               label="StartDate"
               formik={formik}
               name="StartDate"
               width="w-full md:w-1/3 md:-mt-2"
             />
              <NuDate
               label="DueDate"
               formik={formik}
               name="DueDate"
               width="w-full md:w-1/3 md:-mt-2"
             />
              <FormikSelectTwo
               label="Duration"
               Options={[
                  { value: "One Month", label: "One Month" },
                  { value: "One Year", label: "One Year" },
               ]}
               formik={formik}
               placeholder="Choose"
               name="Duration"
               isRequired={true}
               width="w-full md:w-1/3 md:-mt-2"
             />
             <FormikSelectTwo
               label="Priority"
               Options={[
                 { value: "High", label: "High" },
                  { value: "Medium", label: "Medium" },
               ]}
               formik={formik}
               placeholder="Choose"
               name="Priority"
               isRequired={true}
               width="w-full md:w-1/3 md:-mt-2"
             />
             <FormikSelectTwo
               label="Status"
               Options={[
                  { value: "Completed", label: "Completed" },
                  { value: "Pending", label: "Pending" },
               ]}
               formik={formik}
               placeholder="Choose"
               name="Status"
               isRequired={true}
               width="w-full md:w-1/3 md:-mt-2"
             />
              
             
              

           
           
            <div className="w-full  my-4 mt-8 ">
              <div className=" flex justify-end gap-4">
                <CancelButton
                  handleClick={() => {
                    navigate(-1);
                  }}
                />
                <SubmitButton />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default EditTasks;
